<div class="confirm-dialog" [ngStyle]="{ 'max-width': maxWidth }">
  <h2 mat-dialog-title>{{ dialogData.title }}</h2>
  <mat-dialog-content>
    <p [innerHtml]="dialogData.message"></p>
  </mat-dialog-content>
  <mat-dialog-actions [align]="'end'">
    <ts-button variant="secondary" htmlButtonType="button" (buttonClick)="delete()" data-testid="confirm-modal-no">
      No
    </ts-button>
    <ts-button
      variant="primary"
      htmlButtonType="button"
      (buttonClick)="delete(true)"
      data-testid="confirm-modal-yes"
      class="ml-2"
    >
      Yes
    </ts-button>
  </mat-dialog-actions>
</div>
